import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
const IMarkerDecorationsService = createDecorator('markerDecorationsService');

export { IMarkerDecorationsService };
